import React from 'react'
import PropTypes from 'prop-types'

const Templates = ({templates, onSelect}) => {
  return <div className='templates-list'>
    { !templates.length && <h4>No Results</h4> }
    { !!templates.length &&
      templates.map((t, index) => 
        <button className='template-value' key={index} onClick={() => onSelect(t)}>
          <span>{t.title}</span>
        </button>
      )
    }
  </div>
}

Templates.propTypes = {
  templates: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default Templates
